<template>
  <div>
    <template v-if="hasHyperlink">
      <router-link v-bind:to="{ name: data.href.name, params: data.href.params }" class="no-hover">
        <markdown class="markdown">{{data.content}}</markdown>
      </router-link>
    </template>
    <template v-else>
    <markdown class="markdown">{{data.content}}</markdown>
    </template>
  </div>
</template>

<script>
// Component expects:
// - content
export default {

  name: 'component_markdown',

  props: ['data'],

  computed: {

    hasHyperlink() {
      return (this.data.href !== undefined);
    },

  },

};
</script>

<style lang="scss" scoped>
@import '../styles/_typography.scss';
a.no-hover {
  @include type('default', $color--primary-dark);
}
</style>



// WEBPACK FOOTER //
// src/components/markdown.vue